import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/*';
import { RouterModule } from '@angular/router';
import { TourPageComponent } from './tour.page';
import { extractCargoDetail, ExtractStopLabelPipe, ExtractTimeWindowPipe, HasTransportDocumentPipe, IsCustomerToCustomerPipe, IsVendorPipe, TourDetailsComponent } from './tour-details/tour-details.component';
import { TourUpdateComponent } from './tour-update/tour-update.component';
import { StopDetailsComponent } from './stop-details/stop-details.component';
import { TourStopGuard } from './stop-details/tour-stop.guard';
import { TourGuard } from './tour.guard';
import { MachineCardComponent } from './stop-details/machine-card/machine-card.component';
import { InvalidMachinesTxtPipePipe } from './stop-details/invalid-machine-txt.pipe';
import { NonMachineCardComponent } from './stop-details/non-machine-card/non-machine-card.component';
import { SetRasterLocationsComponent } from './set-raster-locations/set-raster-locations.component';
import { RasterLocGuard } from './set-raster-locations/raster-loc.guard';
import { TourStopActionGuard } from './tour-stop-action.guard';
import { ActionDetailsComponent, ActionFuelComponent, ActionInfoComponent, ActionPhotosComponent, ActionSwitchComponent, ContactPersonNamePipe, ContactPersonPhonePipe, CustomerDetailsTxtPipe } from './action-details';
import { NotificationModule } from '../components/notification/notification.module';
import { TransportTSAStatusLabelComponent } from './stop-details/transport-tsa-status-label/transport-tsa-status-label.component';
import { FormsModule } from '@angular/forms';
import { MachineDetailsComponent } from './action-details/machine-details/machine-details.component';
import { BulkSignComponent } from './bulk-sign/bulk-sign.component';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';

import { ActionFuelCreateComponent } from './action-details/action-fuel/action-fuel-create/action-fuel-create.component';
import { ActionFuelContentComponent } from './action-details/action-fuel/action-fuel-content/action-fuel-content.component';
import { ZenithNumericInputFormGroup } from '../components/zenith/form/zenith-numeric-input-form-group/zenith-numeric-input-form-group.component';
import { ProtocolModule } from '../protocol/protocol.module';
import { BulkSignChecklistComponent } from './bulk-sign/bulk-sign-checklist/bulk-sign-checklist.component';
import { PhoneNumberComponent } from '../components/common/phone-number/phone-number.component';
import { FindInstanceComponent } from './action-details/find-instance/find-instance.component';
import { InstanceContainerComponent } from '../components/instance-container/instance-container.component';
import { InstanceTechnicalDetailsCardComponent } from '../components/instance/technical-details-card/instance-technical-details-card.component';
import { InstanceComponent } from '../components/instance/instance.component';
import { CopyToClipboardComponent } from '../components/common/copy-to-clipboard/copy-to-clipboard.component';
import { TransportPurposeBadgeComponent } from '../components/transport/badges-and-icons/purpose-badge/transport-purpose-badge.component';

@NgModule({
  declarations: [
    TourPageComponent,
    TourDetailsComponent,
    TourUpdateComponent,
    StopDetailsComponent,
    MachineCardComponent,
    NonMachineCardComponent,
    InvalidMachinesTxtPipePipe,
    SetRasterLocationsComponent,
    ActionDetailsComponent,
    ActionInfoComponent,
    ActionPhotosComponent,
    ActionSwitchComponent,
    ActionFuelComponent,
    ActionFuelCreateComponent,
    ActionFuelContentComponent,
    MachineDetailsComponent,
    TransportTSAStatusLabelComponent,
    IsVendorPipe,
    HasTransportDocumentPipe,
    IsCustomerToCustomerPipe,
    ExtractTimeWindowPipe,
    ContactPersonPhonePipe,
    ContactPersonNamePipe,
    CustomerDetailsTxtPipe,
    ExtractStopLabelPipe,
    extractCargoDetail,
    BulkSignComponent,
    BulkSignChecklistComponent
  ],
  providers: [TourGuard, TourStopActionGuard, TourStopGuard, RasterLocGuard],
  imports: [
    TranslateModule,
    CommonModule,
    SharedModule,
    RouterModule,
    NotificationModule,
    FormsModule,
    ZenithComponentsModule,
    ZenithNumericInputFormGroup,
    ProtocolModule,
    PhoneNumberComponent,
    FindInstanceComponent,
    InstanceContainerComponent,
    InstanceTechnicalDetailsCardComponent,
    InstanceComponent,
    CopyToClipboardComponent,
    TransportPurposeBadgeComponent,
  ],
  exports: [
    TourDetailsComponent,
    TourUpdateComponent,
    StopDetailsComponent,
    SetRasterLocationsComponent,
    ActionDetailsComponent,
    BulkSignComponent
  ]
})
export class TourModule {}
